<template>
  <div class="custom-select white-bg">
    <el-form>
      <el-row
        :gutter="20"
        class="page-query-content">
        <el-col
          :xs="24" :sm="12" :md="8" :lg="8">
          <el-form-item
            label="渠道"
          >
            <el-select
              v-model="channel"
              clearable
              placeholder="请选择"
              class="vsselect"
              @change="toQuery"
            >
              <el-option
                label="个人"
                value="personal"
              ></el-option>
              <el-option
                v-for="(item,index) in channelList"
                :key="index"
                :label="item.merName"
                :value="item.merCode"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
          :xs="24" :sm="12" :md="8" :lg="8">
          <el-form-item
            label="类型"
          >
            <el-select
              v-model="type"
              clearable
              placeholder="请选择"
              class="vsselect"
              @change="toQuery"
            >
              <el-option
                v-for="(item,index) in typeList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="8">
          <el-form-item
            label="订单时间"
          >
            <el-date-picker
              v-model="time"
              type="daterange"
              clearable
              placeholder="请选择"
              class="vsselect"
              @change="toQuery"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col
          v-if="status === 0"
          :xs="24"
          :sm="12"
          :md="8"
          :lg="8"
        >
          <el-form-item
            label="订单状态"
          >
            <el-select
              v-model="idStatus"
              clearable
              placeholder="请选择"
              class="vsselect"
              @change="toQuery"
            >
              <el-option
                v-for="(item,index) in idStatusList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
  import  selectQuery from '@/mixins/selectQuery'
  import { queryValidMerchants } from '@/api/merchan'
  export default {
    name: "querySelect",
    props: {
      status : {
        type: Number,
        default: 0,
      },
    },
    data() {
      return {
        type: '',
        channel: '',
        channelList: [],
        typeList: [
          {
            label: '转入（上链）',
            value: 1
          },
          {
            label: '转入（非上链）',
            value: 2
          },
          {
            label: '转出（上链） ',
            value: 3
          },
          {
            label: '转出（非上链) ',
            value: 4
          },
        ],
        idStatus: '',
          idStatusList:[
            {
              label: '待审核',
              value: 1
            },
            {
              label: '待支付',
              value: 2
            },
            {
              label: '支付中',
              value: 3
            },
            {
              label: '已支付',
              value: 4
            },
            {
              label: '已完成',
              value: 5
            },
            {
              label: '审核拒绝',
              value: 6
            },
          ],
        time: []
      }
    },
    mixins: [selectQuery],
    created(){
      this.getChannels();
    },
    methods: {
      getChannels() {
        queryValidMerchants().then((res) => {
          console.log(res);
          this.channelList = res.data;
        })
      }
    },
  }
</script>

<style lang="scss" scoped>
  .custom-select {
    margin-bottom: 20px;
  }
  .vsselect {
    width: 100%;
    margin-bottom: 10px;
  }
</style>
